


































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {Game, User} from "@/types";
import {AxiosError, AxiosResponse} from "axios";
import _ from "lodash";
@Component({
    computed: {...mapGetters(["user"]),
        games: function () {
            return _.filter(this['gameList'], {
                    'activated': true
                }
            )
        }
    },
    components: {

    },
})
export default class AllGameCard extends Vue {
    private gameList: Game[] = [];
    private tlUser: any = "";
    private user!: User;

    channel_id: any = '';

    async mounted() {
        await this.$store.dispatch("loginState");

        if (this.$route.params.channel_id) {
            this.channel_id = this.$route.params.channel_id;
        }
        else {
            this.channel_id = this.user.channel_id
        }

        this.fetch();
    }

    fetch() {
        if (this.$store.getters.gameList.length !== 0) {
            this.gameList = this.$store.getters.gameList;
        }
        else {
            this.$api.userChannel(this.channel_id)
                .then((res: any) => {
                    const {target} = res;
                    const {games} = target;
                    this.gameList = games;

                })
                .catch((err: any) => {
                    console.log('err', err)
                })
        }

    }

    addGame() {
        window.location.href = this.$store.getters.studioUrl + "addGame";

    }


    playGame(pathname: string) {
        window.open(
            this.$store.getters.homeUrl + `play/${pathname}`, "_blank");
    }
    moveGamePage(pathname: string){
        this.$router.push(`/${this.$i18n.locale}/timeline/game/${pathname}`)
    }
}
